var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.opened
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v("Delete Remote Host")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _c("p", [
              _vm._v("Are you sure you wish to "),
              _c("strong", [_vm._v("permanently")]),
              _vm._v(" remove “" + _vm._s(_vm.host) + "” as an access host?")
            ])
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: "",
                  text: "",
                  color: "green"
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.loading
                },
                on: {
                  click: _vm.deleteHost
                }
              },
              [_vm._v("Delete")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }